import React from "react";
import styled from "styled-components";
import Logo from "../../images/propwave_logo.png";

const Wrapper = styled.footer`
  position: relative;
  width: 100%;
  height: 200px;
  bottom: 0px;
  left:0px;

  display: flex;

  background: #eeeeee;
`;

const Image = styled.img`
  width: 180px;
  height: 44px;

  position: absolute;
  left: 16.67%;
  right: 73.96%;
  top: 23.5%;
  bottom: 54.5%;
`;
Image.defaultProps = {
  src: Logo,
};

const TextWapper = styled.div`
  position: absolute;

  display: flex;
  flex-direction: column;

  left: 16.67%;
  top: 53%;
`;

const Text = styled.text`
  position: relative;

  font-family: Sandoll GothicNeo1;
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  line-height: 23px;
  /* or 177% */

  color: #999999;
`;

export default function Footer() {
  return (
      <Wrapper>
        <Image />
        <TextWapper>
          <Text>㈜프롭웨이브 김승현</Text>
          <Text>
            010-2775-3120 | minikkim@gmail.com | 서울시 관악구 관악로1
            서울대학교 32-1동 2층 프롭웨이브
          </Text>
        </TextWapper>
      </Wrapper>
  );
}
